import { render, staticRenderFns } from "./TakePic.vue?vue&type=template&id=2e89d55e&"
import script from "./TakePic.vue?vue&type=script&lang=js&"
export * from "./TakePic.vue?vue&type=script&lang=js&"
import style0 from "./TakePic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports